import { render } from "./MenuContent.vue?vue&type=template&id=5490894e&scoped=true&ts=true"
import script from "./MenuContent.vue?vue&type=script&lang=ts"
export * from "./MenuContent.vue?vue&type=script&lang=ts"

import "./MenuContent.vue?vue&type=style&index=0&id=5490894e&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5490894e"]])

export default __exports__